import './App.css';
import "../src/componenten/swiper.css";
import "firebase/storage";
import React from 'react';
import { BrowserRouter , Route } from 'react-router-dom';
import Home from './componenten/Home'
import Impressum from './componenten/impressum'

function App() {
  return (
    <BrowserRouter>
      <div>
          <Route exact path="/" component= {Home} />
          <Route path="/impressum" component= {Impressum} />
      </div>
    </BrowserRouter>
  );
}

export default App;
